"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _InventoryConfigurationList_1 = require("./_InventoryConfigurationList");
exports.ListBucketInventoryConfigurationsOutput = {
    type: "structure",
    required: [],
    members: {
        ContinuationToken: {
            shape: {
                type: "string"
            }
        },
        InventoryConfigurationList: {
            shape: _InventoryConfigurationList_1._InventoryConfigurationList,
            locationName: "InventoryConfiguration"
        },
        IsTruncated: {
            shape: {
                type: "boolean"
            }
        },
        NextContinuationToken: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=ListBucketInventoryConfigurationsOutput.js.map